import { CommonDialogs } from "@mcleod/common";
import { Component, Layout } from "@mcleod/components";
import { CRMMultiSelectErrorSlideout } from "./CRMMultiSelectErrorSlideout";
import { AutogenLayoutCRMMultiSelectErrorModal } from "./autogen/AutogenLayoutCRMMultiSelectErrorModal";
import { ModelRow } from "@mcleod/core";

const layoutPath = "lme/crm/CRMMultiSelectErrorModal"

export class CRMMultiSelectErrorModal extends AutogenLayoutCRMMultiSelectErrorModal {
    public static async showModal( title: string, successCount: number, failedRows: ModelRow[]) {
        const modalLayout = Layout.getLayout(layoutPath) as CRMMultiSelectErrorModal;
        const modal = CommonDialogs.createDialog(modalLayout, {
            centerInParent: true,
            title,
            panelTitleProps:{
                backgroundColor: "primary.darker",
                color: "primary.reverse"
            },
            movable: true,
            minWidth: 350
        });
        modalLayout.addLayoutDataLoadListener(() => {
            modalLayout.labelSuccessfulOrderCount.text = successCount.toString();
            const failedCount = failedRows.length;
            modalLayout.labelFailedOrderCount.text = failedCount.toString();
            if (failedCount > 0) {
                modalLayout.labelFailedOrderCount.color = "error";
                modalLayout.labelFailedLink.addClickListener(() =>
                    CRMMultiSelectErrorSlideout.showSlideout(failedRows));
            }
            else {
                modalLayout.labelFailedLink.visible = modalLayout.labelFailedPipe.visible = false;
            }
        });
        modal.show();
    }
}
